import { createSlice } from '@reduxjs/toolkit';
import moment from 'moment';
import {
  addDaysToDateHelper,
  formatDateHelper,
  subtractDaysFromDateHelper,
} from '@/utils/dateUtils';

const DEFAULT_PAST_DAYS = Number(import.meta.env.VITE_DEFAULT_PAST_DAYS) || 90;
const DEFAULT_FUTURE_DAYS =
  Number(import.meta.env.VITE_DEFAULT_FUTURE_DAYS) || 90;

const createInitialState = () => ({
  startDate: formatDateHelper({
    date: subtractDaysFromDateHelper(moment(), DEFAULT_PAST_DAYS).toDate(),
  }),
  endDate: formatDateHelper({
    date: addDaysToDateHelper(moment(), DEFAULT_FUTURE_DAYS).toDate(),
  }),
  includeRecordsWithNullReleaseDate: true,
  jiraProjects: [],
  selectedJiraProjects: [],
});

const releaseTestCasesDashboardSlice = createSlice({
  name: 'releaseTestCasesDashboard',
  initialState: createInitialState(),
  reducers: {
    setDates: (state, action) => {
      const { startDate, endDate } = action.payload;
      state.startDate = startDate
        ? formatDateHelper({ date: moment(startDate).toDate() })
        : null;
      state.endDate = endDate
        ? formatDateHelper({ date: moment(endDate).toDate() })
        : null;
    },

    setIncludeNullRecords: (state, action) => {
      state.includeRecordsWithNullReleaseDate = action.payload;
    },

    setJiraProjects: (state, action) => {
      state.jiraProjects = action.payload;
    },

    setSelectedJiraProjects: (state, action) => {
      state.selectedJiraProjects = action.payload;
    },

    setAllDates: (state, action) => {
      const { startDate, endDate, includeRecordsWithNullReleaseDate } =
        action.payload;

      state.startDate = startDate
        ? formatDateHelper({ date: moment(startDate).toDate() })
        : null;
      state.endDate = endDate
        ? formatDateHelper({ date: moment(endDate).toDate() })
        : null;
      state.includeRecordsWithNullReleaseDate =
        includeRecordsWithNullReleaseDate ?? true;
    },

    resetDates: () => createInitialState(),
  },
});

export const {
  setDates,
  setIncludeNullRecords,
  setJiraProjects,
  setSelectedJiraProjects,
  setAllDates,
  resetDates,
} = releaseTestCasesDashboardSlice.actions;

export default releaseTestCasesDashboardSlice.reducer;
